import LogoWhite from "../assets/logo/Logo_White.svg";
import { servicesDataEn, servicesDataAr } from "../data/servicesData";
import { useLanguage } from "../LanguageContext";

export default function Footer({ navigate }) {
  const { isAr } = useLanguage();
  const servicesData = isAr ? servicesDataAr : servicesDataEn;
  const t = (en, ar) => (isAr ? ar : en);

  return (
    <footer className="text-white pt-10 sm:pt-12 border-t-4 border-primary-600 bg-[#10172b]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-6 sm:pb-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-0 sm:gap-10 lg:gap-12 pb-10 border-b border-white/10">
          {/* Quick Links — top-left on mobile */}
          <div className="pb-8 sm:pb-0 order-1 lg:order-2">
            <h4 className="font-bold uppercase text-white mb-4 tracking-wider text-sm">
              {t("Quick Links", "روابط سريعة")}
            </h4>
            <ul className="space-y-3 text-sm">
              {[
                { view: "home", en: "Home", ar: "الرئيسية" },
                { view: "services", en: "Services", ar: "الخدمات" },
                { view: "projects", en: "Projects", ar: "المشاريع" },
                { view: "about", en: "About Us", ar: "من نحن" },
                { view: "contact", en: "Contact Us", ar: "تواصل معنا" },
              ].map(({ view, en, ar }) => (
                <li key={view}>
                  <button
                    onClick={() => navigate && navigate(view)}
                    className="text-white/80 transition-colors duration-200 hover:text-axion-gold"
                  >
                    {t(en, ar)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services — top-right on mobile */}
          <div className="pb-8 sm:pb-0 order-2 lg:order-3">
            <h4 className="font-bold uppercase text-white mb-4 tracking-wider text-sm">
              {t("Services", "الخدمات")}
            </h4>
            <ul className="space-y-3">
              {Object.entries(servicesData).map(([key, service]) => (
                <li key={key}>
                  <button
                    onClick={() => navigate && navigate("service-detail", key)}
                    className="text-white/80 text-sm text-left transition-colors duration-200 hover:text-axion-gold"
                  >
                    {service.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Logo & Description — bottom-left on mobile */}
          <div className="flex flex-col items-start gap-3 sm:gap-4 pt-8 sm:pt-0 order-3 lg:order-1">
            <img src={LogoWhite} alt="Axion Railway Logo" className="h-8 sm:h-10 w-auto mb-1 sm:mb-2" loading="lazy" />
            <p className="text-white/80 text-sm sm:text-base max-w-xs">
              {t(
                "Reliable cable construction and engineering expertise you can trust.",
                "خبرة موثوقة في إنشاء الكابلات والهندسة يمكنك الاعتماد عليها."
              )}
            </p>
          </div>

          {/* Connect — bottom-right on mobile */}
          <div className="pt-8 sm:pt-0 order-4 lg:order-4">
            <h4 className="font-bold uppercase text-white mb-3 sm:mb-4 tracking-wider text-sm">
              {t("Connect", "تواصل")}
            </h4>
            <ul className="space-y-3 text-white/80 text-sm">
              <li className="flex items-start gap-3">
                <i className="ph-bold ph-map-pin text-base mt-0.5 text-axion-gold" />
                <span>
                  {isAr ? (
                    <>طريق الملك فهد، حي العليا<br />الرياض 12211<br />المملكة العربية السعودية</>
                  ) : (
                    <>King Fahd Road, Olaya District<br />Riyadh 12211<br />Saudi Arabia</>
                  )}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ph-bold ph-phone text-base text-axion-gold" />
                <span dir="ltr">+966 50 348 5621</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ph-bold ph-envelope text-base text-axion-gold" />
                <span dir="ltr">info@axionrailway.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4 pt-6 sm:pt-8 text-white/60 text-xs sm:text-sm">
          <p>
            &copy; {"2024 "}
            {t("Axion Railway. All rights reserved.", "أكسيون للسكك الحديدية. جميع الحقوق محفوظة.")}
          </p>
          <div className="flex flex-wrap gap-4 sm:gap-6 items-center justify-center">
            <button
              onClick={() => navigate && navigate("privacy-policy")}
              className="transition-colors duration-200 hover:text-axion-gold"
            >
              {t("Privacy Policy", "سياسة الخصوصية")}
            </button>
            <button
              onClick={() => navigate && navigate("terms-of-service")}
              className="transition-colors duration-200 hover:text-axion-gold"
            >
              {t("Terms of Service", "شروط الخدمة")}
            </button>
            <a
              href="https://qr.saudibusiness.gov.sa/viewcr?nCrNumber=5z4t5kG8/vlx9K+xSNVE9Q=="
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors duration-200 flex items-center gap-1 hover:text-axion-gold"
            >
              {t("C.R. Details", "تفاصيل السجل التجاري")} <i className="ph-bold ph-globe text-sm" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
